import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <div>
        <h1>Refund Calculator Under Construction</h1>
        <p>This application will house front-end capabilities for quoting and performing cancellations and/or refunds.</p>
      </div>
    );
  }
}
